function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import { PATTERNS_VALIDATION } from '@/js/constants';
import { crudUserProfileAssigment } from '@/mixins/crud_userprofile_assignment.js';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import PaginationBasic from '@/components/PaginationBasic.vue';
import utils from '@/js/utils';
export default {
  name: 'ProfileAssigmentPage',
  mixins: [crudUserProfileAssigment],
  components: {
    PaginationBasic: PaginationBasic
  },
  data: function data() {
    return {
      alert: false,
      select_profile_users: [],
      select_profile_areas: [],
      areas_aux: [],
      profile_aux: [],
      select_profile_assignments: [],
      modalId: 'dp_profileassignment',
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      dialogFlag: false,
      collapse_filter: false,
      profileFiltered: [],
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      key_pagination: 1,
      filters: {},
      valid: true,
      renew_data: null
    };
  },
  computed: {
    /* ...mapState('data-platform', [
      'select_profile_users',
      'select_profile_areas',
      'select_profile_assignments'
    ]),*/
    headers: function headers() {
      return [{
        value: 'user_name',
        text: this.traductor('tablas.user'),
        sortable: true,
        class: 'text-left'
      }, {
        value: 'area_description',
        text: this.traductor('tablas.area'),
        sortable: true,
        class: 'text-left'
      }, {
        value: 'userprofile_description',
        text: this.traductor('tablas.profile'),
        sortable: true,
        class: 'text-left'
      }, {
        value: 'user_position',
        text: this.traductor('tablas.position'),
        sortable: true,
        class: 'text-left'
      }, {
        value: 'supervisor_email',
        text: this.traductor('tablas.supervisor'),
        sortable: true,
        class: 'text-left',
        align: 'center'
      }, {
        value: 'flag_active',
        text: this.traductor('tablas.status'),
        sortable: true,
        class: 'text-left',
        align: 'center'
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        class: 'text-center',
        align: 'left'
      }];
    },
    texts: function texts() {
      return {
        user: this.traductor('tablas.user'),
        position: this.traductor('tablas.position'),
        supervisor: this.traductor('tablas.supervisor'),
        area: this.traductor('tablas.area'),
        profile: this.traductor('tablas.profile'),
        active: this.traductor('frases.activo'),
        updated_by: this.traductor('frases.updated_by'),
        update_date: this.traductor('frases.update_date'),
        applicant: this.traductor('tablas.applicant')
      };
    },
    modalName: function modalName() {
      return this.traductor('menu.dp.up_profile_assignments');
    },
    readonly: function readonly() {
      return ['view', 'edit'].includes(this.mode);
    },
    disable_check_active: function disable_check_active() {
      return this.mode !== 'edit';
    },
    rows: function rows() {
      return this.select_profile_assignments.length;
    }
  },
  watch: {
    'record.flag_active': {
      handler: function handler(value, old) {
        if (value && old !== undefined) {
          this.checkActive();
        }
      }
    }
  },
  created: function created() {
    this.getAreas();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    uppercase: function uppercase() {
      this.record.user_position = this.record.user_position.toUpperCase();
    },
    getRecords: function getRecords() {
      var _this = this;
      this.parametros = {
        pagination: utils.cloneJSON(this.pagination),
        domain: 'intercorp.com.pe',
        values: {
          'area_id': '',
          'userprofile_id': ''
        }
      };
      this.parametros.pagination.limit++;
      this.toggleBusy();
      UserProfileService.getAssignments(this.parametros).then(function (data) {
        _this.toggleBusy();
        console.log(data);
        _this.select_profile_assignments = data.data;
        if (_this.select_profile_assignments.length == _this.pagination.limit + 1) {
          _this.select_profile_assignments.splice(_this.select_profile_assignments.length - 1, 1);
          _this.pagination.total = _this.pagination.limit;
          _this.pagination.next = true;
          _this.key_pagination += 1;
        } else {
          _this.pagination.total = _this.pagination.limit - 1;
          _this.pagination.next = false;
          _this.key_pagination += 1;
        }
      }, function (err) {
        _this.toggleBusy();
        console.og(err);
      });
    },
    cambiarPagina: function cambiarPagina(currentPage) {
      this.pagination.current = currentPage;
      this.pagination.offset = (this.pagination.current - 1) * this.pagination.limit;
      this.getRecords();
    },
    getAreas: function getAreas() {
      var _this2 = this;
      this.parametros = {
        // pagination: {"limit":10000,"offset":0},
        domain: 'intercorp.com.pe'
      };
      UserProfileService.getAreas(this.parametros).then(function (data) {
        console.log(data);
        // this.select_profile_areas = data.data;
        _this2.areas_aux = data.data;
        console.log('areas aux:', _this2.areas_aux);
        data.data.forEach(function (element) {
          _this2.select_profile_areas.push({
            value: element.area_id,
            text: element.area_description
          });
        });
      }, function (err) {
        console.og(err);
      });
    },
    onDownload: function onDownload() {
      var _this3 = this;
      var columns = ['area_id', 'area_description', 'userprofile_id', 'userprofile_description', 'user_name', 'user_position', 'supervisor_email', 'applicant_email', 'project_name', 'dataset_name', 'table_name', 'accesstype_id', 'default_accesstime_months', 'flag_active', 'start_date', 'end_date', 'load_date', 'record_source', 'creator_user'];
      var body = [columns.join(';')];
      var parametros = {
        'domain': 'intercorp.com.pe'
      };
      this.busy2 = !this.busy2;
      UserProfileService.downloadAssignments(parametros).then(function (response) {
        var row = [];
        var _iterator = _createForOfIteratorHelper(response.data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var record = _step.value;
            for (var _i = 0, _columns = columns; _i < _columns.length; _i++) {
              var column = _columns[_i];
              row.push(record[column]);
            }
            row = row.join(';');
            body.push(row);
            row = [];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var data = body.join('\n');
        var fileName = "".concat(_this3.modalId, ".csv");
        tasks.saveData(data, fileName);
        _this3.busy2 = !_this3.busy2;
      });
    },
    checkFormValidity: function checkFormValidity() {
      var _this4 = this;
      if (this.mode === 'create') {
        var record_filtered = this.select_profile_assignments.filter(function (rec) {
          return rec.user_name === _this4.record.user_name && rec.flag_active;
        });
        var record_filtered_by_area = this.select_profile_assignments.filter(function (rec) {
          return rec.user_name === _this4.record.user_name && rec.userprofile_id === _this4.record.userprofile_id && rec.area_id === _this4.record.area_id && rec.flag_active == true;
        });
        if (record_filtered.length) {
          //this.dismissCountDown = this.dismissSecs
          tasks.toast.error("Username is already active");
          //this.dangerMessage = 'Username is already active'
          return false;
        } else if (record_filtered_by_area.length) {
          //this.dismissCountDown = this.dismissSecs
          tasks.toast.error("Area and Profile already have been assigned for this username");
          //this.dangerMessage = 'Area and Profile already have been assigned for this username'
          return false;
        }
      } else if (this.mode === 'edit') {
        if (this.record.flag_active) {
          return this.checkActive();
        }
      }
      return valid;
    },
    checkActive: function checkActive() {
      var _this5 = this;
      var records = this.select_profile_assignments.filter(function (rec) {
        return rec.record_id !== _this5.record.record_id && rec.user_name === _this5.record.user_name && rec.flag_active;
      });
      if (records.length) {
        tasks.toast.error("Username is already active");
        //this.dismissCountDown = this.dismissSecs
        //this.dangerMessage = 'Username is already active'
        return false;
      }
      return true;
    },
    onRenewConfirm: function onRenewConfirm(data) {
      this.renew_data = data;
      this.$refs['modal_confirm_renovar'].onOpen();
    },
    onRenovarAsignacion: function onRenovarAsignacion(ope) {
      if (ope) {
        this.onRenew();
      }
      this.$refs['modal_confirm_renovar'].onClose();
    },
    onRenew: function onRenew() {
      var _this6 = this;
      var consulta = {
        'email': this.renew_data.item.applicant_email,
        'record_id': this.renew_data.item.record_id,
        'area_id': this.renew_data.item.area_id,
        'userprofile_id': this.renew_data.item.userprofile_id
      };
      UserProfileService.reloadAssignment(consulta).then(function (response) {
        if (response.success) {
          tasks.toast.success('La asignación se ha vuelto a realizar.');
          _this6.getRecords();
        } else {
          tasks.toast.error('No se pudo realizar la operación.');
        }
      });
    },
    parseToLowerCase: function parseToLowerCase(value) {
      return value.toLowerCase();
    }
  }
};